import { ActiveEnums } from "@app/data/engine.ts";
import { AssignmentBudgetFilters as DataAssignmentBudgetFilters } from "@app/data-hooks/use-budget-data.ts";
import { EntryFiltersModel } from "@app/data-hooks/use-entries-data.ts";
import moment from "moment";

export interface AssignmentFilter {
    client: { id: number; label: string } | undefined;
    extension: number | undefined;
    activeState: ActiveEnums;
    searchDesc: string;
}

export type AssignmentBudgetFilters = {
    rateType: "billing" | "cost" | "internal";
} & DataAssignmentBudgetFilters;

export type AssignmentVisualizationsFilters = {
    staffIds: number[] | undefined;
};

export interface ClientFilter {
    stateCode: number | undefined;
    activeState: ActiveEnums;
    search: string | undefined;
}

export interface InvoicingFilters {
    start: string;
    end: string;
    assignmentId: number | undefined;
    finalizeOnly: boolean;
}

export interface StaffFilter {
    roleId: string | undefined;
    activeState: ActiveEnums;
    hourlyState: ActiveEnums;
}

export const defaultAssignmentFilter: AssignmentFilter = {
    client: undefined,
    extension: undefined,
    activeState: ActiveEnums.ActiveOnly,
    searchDesc: "",
};

export const defaultAssignmentBudgetFilter: AssignmentBudgetFilters = {
    rateType: "cost",
};

export const defaultAssignmentVisualizationsFilters: AssignmentVisualizationsFilters = {
    staffIds: undefined,
};

export const defaultClientFilters: ClientFilter = {
    stateCode: undefined,
    activeState: ActiveEnums.ActiveOnly,
    search: undefined,
};

export const defaultEntryFilters: EntryFiltersModel = {
    to: moment().format("MM/DD/YYYY"),
    from: moment().startOf("month").format("MM/DD/YYYY"),
};

export const defaultInvoicingFilters: InvoicingFilters = {
    start: moment().subtract(1, "month").startOf("month").format("MM/DD/YYYY"),
    end: moment().format("MM/DD/YYYY"),
    assignmentId: undefined,
    finalizeOnly: true,
};

export const defaultStaffFilters: StaffFilter = {
    roleId: undefined,
    activeState: ActiveEnums.ActiveOnly,
    hourlyState: ActiveEnums.All,
};
